module.exports = __webpack_public_path__ + "media/img/payments/monitor-icon-214daff8e7d53064d6211af1af11d373.svg";